function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3523",
  "data-name": "Path 3523",
  d: "M82.781-137.906v22.313H80.156q-18.375.281-29.578,9.563T37.125-80.25Q48-91.312,64.594-91.312q17.813,0,28.313,12.75T103.406-45a50.275,50.275,0,0,1-5.766,24.094A41.35,41.35,0,0,1,81.328-4.125a47.391,47.391,0,0,1-23.859,6q-21.562,0-34.828-15T9.375-53.156v-9.75q0-22.219,8.391-39.234a61.524,61.524,0,0,1,24.094-26.344q15.7-9.328,36.422-9.422ZM56.344-69.562a21.617,21.617,0,0,0-11.906,3.422,20.606,20.606,0,0,0-7.875,9.047v8.25q0,13.594,5.344,21.234a17.258,17.258,0,0,0,15,7.641,17.067,17.067,0,0,0,14.109-6.891q5.391-6.891,5.391-17.859,0-11.156-5.437-18A17.709,17.709,0,0,0,56.344-69.562Z",
  transform: "translate(-9.375 137.906)",
  fill: "#f37320",
  opacity: 0.1
});

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.031,
    height: 139.781,
    viewBox: "0 0 94.031 139.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.6e8c8349748b525a9c5cb3f13d0bb84f.svg";
export { ForwardRef as ReactComponent };